import {ToastrService} from 'ngx-toastr';

export interface DepartureAirportLimitCheckOptions {
    currentCount: number;
    maxCount: number;
    isFreeUser?: boolean;
    showUpgradeModal?: boolean;
    itemLabelSingular?: string;
    itemLabelPlural?: string;
}

export enum LimitReachedAction {
    None = 'none',
    ShowToast = 'show_toast',
    EmitEvent = 'emit_event',
    ReplaceOldest = 'replace_oldest'
}

export interface DepartureAirportLimitCheckResult {
    limitReached: boolean;
    action: LimitReachedAction;
}

export function checkDepartureAirportLimit(
    options: DepartureAirportLimitCheckOptions ,
    toastService?: ToastrService
): DepartureAirportLimitCheckResult {
    const {
        currentCount,
        maxCount,
        isFreeUser = false,
        showUpgradeModal = false,
        itemLabelSingular = 'item',
        itemLabelPlural
    } = options;

    if (currentCount < maxCount) {
        return {
            limitReached: false,
            action: LimitReachedAction.None
        };
    }

    const limitReached = true;

    if (isFreeUser && !showUpgradeModal) {
        return {
            limitReached,
            action: LimitReachedAction.ReplaceOldest
        };
    }

    if (showUpgradeModal) {
        return {
            limitReached,
            action: LimitReachedAction.EmitEvent
        };
    }

    if (toastService) {
        const label = itemLabelPlural || (maxCount > 1 ? `${itemLabelSingular}s` : itemLabelSingular);
        toastService.warning(
            `You can choose up to ${maxCount} ${label}`,
            'Limit Reached'
        );
    }

    return {
        limitReached,
        action: LimitReachedAction.ShowToast
    };
}
